import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProductoService } from '../../servicios/producto.service'
import { FormBuilder, Validators } from '@angular/forms';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { MdcSnackbar } from '@angular-mdc/web';
import { Globals } from '../../globals';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-modal-producto-detalle',
  templateUrl: './modal-producto-detalle.component.html',
  styleUrls: ['./modal-producto-detalle.component.scss']
})
export class ModalProductoDetalleComponent implements OnInit {

	constructor(
    @Inject(MAT_DIALOG_DATA) public data,
		private fb: FormBuilder,
		private productoService: ProductoService,
		// private snackBar: MdcSnackbar,
		private router: Router,
		public dialogRef: MatDialogRef<ModalProductoDetalleComponent>,
		public globals: Globals,
    private snackBar: MatSnackBar
	) { }

  producto = {
    cargando: false,
    data:{
      stockid: "",
      precio_final_con_impuesto: 0,
      detalle:"",
      tags:[]
    },
    total : "0.00"
  }

	formComportamiento = {
		enviando: false
	};

	form = this.fb.group({
		stockid:[
			this.data.producto.stockid,
			[
				Validators.required
			]
		],
		cantidad:[
			1,
			[
				Validators.required
			]
		]
	});

  formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  inputEvent( cantidad ){
    this.producto.total = this.formatter.format( this.producto.data.precio_final_con_impuesto * parseFloat( cantidad ) );
  }

  incrementarCantidad(){
    let valor = parseInt(this.form.controls.cantidad.value);
    this.form.controls.cantidad.setValue( ++valor );
    this.producto.total = this.formatter.format( this.producto.data.precio_final_con_impuesto * valor );
  }

  disminuirCantidad(){
    let valor = parseInt(this.form.controls.cantidad.value);
    if( valor > 1 ){
      this.form.controls.cantidad.setValue( --valor );
      this.producto.total = this.formatter.format( this.producto.data.precio_final_con_impuesto * valor );
    }
  }

  customOptions: OwlOptions = {
		items: 1,
		margin: 10,
		autoHeight: true,
		loop: false,
		mouseDrag: true,
		touchDrag: true,
		pullDrag: true,
		dots: true,
		navSpeed: 700,
		navText: ['', ''],
		nav: false,
    //lazyLoad: true
  }

  detalleProducto(){

    this.producto.data = this.data.producto;
    this.producto.data.detalle = this.data.producto.detalle.replace(/\n/g, '<br>');;
    this.producto.total = this.formatter.format( this.producto.data.precio_final_con_impuesto * parseFloat( this.form.controls.cantidad.value ) );
  }
  seCerro() {
    this.globals.configuracion.modalproducto = null;
  }
  agregarProducto( cotizar = false ){
    this.formComportamiento.enviando = true;

    this.productoService.productoAgregarAlCarro({
      stockid: this.producto.data.stockid,
      cantidad: this.form.controls.cantidad.value,
      typeabbrev: this.globals.configuracion.front.typeabbrev
    }).subscribe(
      resultado =>{
        if( !resultado.error ){
          this.globals.setDataToken( resultado.dataToken );


          let indexProduct = this.globals.configuracion.front.cart.productos.find( element => element.stockid == this.data.producto.stockid );
          if( indexProduct !== undefined ){
            //let cantidad = indexProduct.cantidad;
            //indexProduct = this.data.producto;
            indexProduct.cantidad += parseFloat( this.form.controls.cantidad.value );
          }else{
            this.data.producto.cantidad = parseFloat( this.form.controls.cantidad.value );
            this.globals.configuracion.front.cart.productos.push( this.data.producto );
          }

          var total = 0;
          for( let x = 0; x < this.globals.configuracion.front.cart.productos.length; x++ ){
            total += this.globals.configuracion.front.cart.productos[x].precio_final_con_impuesto * this.globals.configuracion.front.cart.productos[x].cantidad;
          }
          
          this.globals.configuracion.front.cart.total = this.formatter.format( total );

          this.globals.setDataFront();

          this.snackBar.open(`Producto agregado al carrito`, ' ', {
          
            duration: 1000 
          });

          

          if( cotizar ){
            this.router.navigate(['/cotizar']);
          }
          this.dialogRef.close();
        }else{
          //console.log("Error",resultado.mensaje);
          this.snackBar.open(resultado.mensaje, ' ', {
            duration: 1000 
          });
        }

        this.formComportamiento.enviando = false;
      },
      error =>{
        //console.log("Error",error);
        this.snackBar.open(`Error de conexión. Vuelva a intentarlo`, ' ', {
          duration: 1000 
        });

        this.formComportamiento.enviando = false;
      }
    )
  }

  agregarProductoCotizar(){
    this.agregarProducto( true );
  }

  ngOnInit(): void {
    this.detalleProducto();
  }

}
